import PSelect from './src/select'
import POption from './src/option'
import POptionGroup from './src/option-group'
import PSelectDropdown from './src/select-dropdown'

const components = [PSelect, POption, POptionGroup, PSelectDropdown]

const install = function (Vue) {
  components.forEach(comp => {
    Vue.component(comp.name, comp)
  })
}

export default {
  install
}

export { PSelect, POption, POptionGroup, PSelectDropdown }
